export function compare() {
    var src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return JSON.stringify(src) === JSON.stringify(target);
}